<script setup lang="ts">
  import { FormFieldContainer, UiButton, InputField } from '@logistiek-zonder-papier/lzp-library'

  import ConfigurationList from '@/components/form-wizard/ConfigurationList.vue'
  import { computed, ref, watch } from 'vue'

  const model = defineModel<Record<string, string>>({ required: true })
  const keyInput = ref('')
  const error = ref('')

  const keys = computed(() => Object.keys(model.value))

  watch(keyInput, newValue => {
    const storageKey = newValue.trim()
    error.value = keys.value.includes(storageKey) ? 'Key bestaat al!' : ''
  })

  function addKey() {
    const storageKey = keyInput.value.trim()
    if (storageKey && !keys.value.includes(storageKey)) {
      model.value = { ...model.value, [storageKey]: '' }
      keyInput.value = ''
    }
  }
</script>

<template>
  <div class="config-scroll">
    <ConfigurationList v-model="model" />
  </div>
  <FormFieldContainer label="Nieuwe key" :error="error">
    <template #action-button>
      <UiButton class="add-btn" @click="addKey" icon="plus" size="small" />
    </template>
    <InputField
      type="text"
      autofocus
      required
      placeholder="Voer een key in..."
      v-model="keyInput"
      @keydown.enter="addKey"
    />
  </FormFieldContainer>
</template>

<style scoped>
  .add-hidden {
    gap: 0.5rem;
  }

  .config-scroll {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
    width: 100%;
  }
</style>
